import { useEffect, useState } from "react";
import { profileStore } from "../store/profileStore";
import type { ProfileState } from "../store/profileStore";

export function useDomainProfile(domain: string): {
  profileState: ProfileState;
  startResolve: (forceRefresh?: boolean, overrideDomain?: string) => void;
  retryResolve: () => void;
} {
  const [profileState, setProfileState] = useState<ProfileState>(() => profileStore.getState(domain));

  useEffect(() => {
    if (!domain) return;
    const unsubscribe = profileStore.subscribe(domain, (state) => {
      setProfileState(state);
    });
    return () => {
      unsubscribe();
    };
  }, [domain]);

  const startResolve = (forceRefresh = false, overrideDomain?: string) => {
    profileStore.start(overrideDomain || domain, forceRefresh);
  };

  const retryResolve = () => {
    profileStore.retry(domain);
  };

  return { profileState, startResolve, retryResolve };
}
